import { useAppSelector } from 'store/hooks';
import { getCurrencyString } from 'lib/helpers';
import * as React from 'react';
export const useCurrencyString = (currencyCode?: string) => {
    const region = useAppSelector(state => state.settings.settings?.region);
    const getCurrencyStringWrapper = React.useCallback(
        (value: number) => getCurrencyString(value, currencyCode ?? region?.currencyCode),
        [currencyCode, region?.currencyCode]
    );

    return getCurrencyStringWrapper;
};
